import React from "react";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import _ from "lodash";
import { createSafeStorage } from "./safeStorage";

const { detect } = require("detect-browser");

const browser = detect();

const initialState = {
  user: null,
  anonUser: null,
  // False until Firebase restoration (and any impersonation validation) finishes.
  loadedUser: false,
  isSW2: true,
  isMac: browser?.os?.includes("Mac OS") || browser?.os?.includes("iOS"), // used when we need different styles for Mac vs PC
  mergeAccount: false, // Set to true if anonymous user signs up after commenting
};

export const useAppStore = create(
  persist(
    (set) => ({
      ...initialState,

      setUser: (user) => set({ user }),
      setAnonUser: (anonUser) => set({ anonUser }),
      setLoadedUser: (loadedUser) => set({ loadedUser }),
      setMergeAccount: (mergeAccount) => set({ mergeAccount }),

      // TODO: Remove this after 2.0 general release
      setIsSW2: (isSW2) => set({ isSW2 }),


      reset: () => set(initialState),
    }),
    {
      name: "app-store",
      storage: createJSONStorage(() => createSafeStorage(typeof window !== "undefined" ? window.localStorage : null)),
      partialize: (state) => ({ isSW2: state.isSW2 }),
    }
  )
);

export const withAppStore = (BaseComponent) => {
  const MemoizedBaseComponent = React.memo(BaseComponent, (prev, next) => {
    return _.isEqual(prev, next);
  });

  return (props) => {
    const selector = (state) => {
      return {
        isMac: state.isMac,
      };
    };

    const selectedState = useAppStore(selector);

    return (
      <MemoizedBaseComponent
        {...props}
        appStore={selectedState}
      />
    );
  };
};
